var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2098_55752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.67 7.19712V6.53028C12.67 5.79342 12.0732 5.1966 11.3363 5.1966H8.35886C8.13613 5.1966 7.92741 5.08524 7.80405 4.89986L6.86647 3.49349C6.74243 3.30744 6.53438 3.19608 6.31166 3.19608H3.33421C2.59735 3.19608 2.00052 3.7929 2.00052 4.52976V13.1007C2.00052 13.5235 2.34261 13.8655 2.76539 13.8655C3.10281 13.8655 3.40089 13.6441 3.49758 13.3207L5.04932 8.14804C5.2187 7.58323 5.73817 7.19712 6.32699 7.19712H12.8894C13.7796 7.19712 14.4198 8.05202 14.169 8.90624L12.9947 12.9073C12.828 13.4754 12.3072 13.8655 11.7151 13.8655H2.76539",
    stroke: "white",
    strokeWidth: 1.00026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2098_55752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0042,
    height: 16.0042,
    fill: "white",
    transform: "translate(0 0.528717)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.4a52139c354fca4370b933b9218dd2a3.svg";
export { ForwardRef as ReactComponent };